import React from "react";
import DataTable from "../../components/data-table";
import * as userservice from "../../services/user/user-service";
import * as validation from "../../utils/validations";
import { Authorize } from "../../components/authorize";
import Utility from "../../components/modal";
import * as Loader from "../../common/common";

export default class AdminCreateUser extends Authorize {
  constructor(props) {
    super(props);
    this.buttonClick = this.buttonClick.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  state = {
    user: {
      name: "",
      email: "",
      mobile: "",
      role: "",
      userActivate: true,
      password: "",
      repeatPassword: "",
      infoId: "",
      department: [],
      accessRights: [],
    },
    isAllowCreate: false,
    isAllowEdit: false,
    isAllowDelete: false,
    userId: "",
    validationErrors: {},
    msg: "",
    error: "",
    deleteMsg: "",
    edit: false,
    showModel: false,
    selectRoles: [],
    selectDepartments: [],
    headers: [
      { title: "Name", accessor: "name", index: 0, dataType: "string" },
      { title: "Email", accessor: "email", index: 1, dataType: "string" },
      { title: "Mobile", accessor: "mobile", index: 2, dataType: "string" },
      {
        title: "Department",
        accessor: "deptartmentName",
        index: 3,
        dataType: "string",
      },
      { title: "Role", accessor: "role", index: 4, dataType: "string" },
      {
        title: "Actions",
        accessor: "",
        index: 5,
        cell: (row) => {
          return (
            <React.Fragment>
              <div className="btn-group ">
                {this.state.isAllowEdit ? (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary fas fa-edit rounded-0"
                    onClick={this.edit.bind(this, row.userId)}
                  ></button>
                ) : (
                  ""
                )}
                {this.state.isAllowDelete ? (
                  <button
                    type="button"
                    className="btn btn-sm btn-danger fas fa-trash-alt rounded-0"
                    onClick={this.delete.bind(this, row.userId)}
                  ></button>
                ) : (
                  ""
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    data: [],
  };
  async edit(id, e) {
    Loader.showLoader();
    let userDetail = await userservice.getUser({ id: id });
    let user = userDetail.response.data;
    Loader.hideLoader();
    this.setState({
      showModel: true,
      edit: true,
      msg: "",
      error: "",
      user: user,
      userId: id,
    });
  }

  async delete(id, e) {
    var that = this;
    var config = {
      message: "Are you sure you want to delete this user?",
      onYesClick: async function () {
        Loader.showLoader();
        let { response, err } = await userservice.deleteUser(id);
        Loader.hideLoader();
        if (err) {
        } else if (response.data && response.data.err) {
        } else {
          that.setState(
            {
              deleteMsg: response.data.msg,
            },
            () => {
              setTimeout(() => that.setState({ deleteMsg: "" }), 10000);
            }
          );
          that.getAllInternalUsers();
        }
      },
      onNoClick: null,
    };
    Utility.showConfirm(config);
  }

  buttonClick() {
    this.setState({
      showModel: !this.state.showModel,
      user: {
        name: "",
        email: "",
        mobile: "",
        role: "",
        userActivate: true,
        password: "",
        repeatPassword: "",
        department: [],
        infoId: "",
      },
      validationErrors: {},
      userId: "",
      edit: false,
      msg: "",
      error: "",
    });
  }

  onChange(e) {
    let name = e.target.name;
    let value;
    if (name === "department") {
      if (e.target.checked === true) {
        value = [...this.state.user.department, e.target.value];
      } else {
        var filterVal = this.state.user.department.filter((f) => {
          return f !== e.target.value;
        });
        value = filterVal;
      }
    } else if (name === "userActivate") {
      if (e.target.checked === true) {
        value = true;
      } else {
        value = false;
      }
    } else {
      value = e.target.value;
    }
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "name") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.nameError = "Please enter Name";
      } else {
        validationErrors.nameError = "";
      }
    } else if (name === "email") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.emailError = "Please enter Email";
      } else {
        validationErrors.emailError = "";
      }
    } else if (name === "mobile") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.mobileError = "Please enter Mobile No.";
      } else {
        validationErrors.mobileError = "";
      }
    } else if (name === "password") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.passwordError = "Please enter Password";
      } else {
        validationErrors.passwordError = "";
      }
    } else if (name === "repeatPassword") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.repeatPasswordError = "Please enter Confirm Password";
      } else {
        validationErrors.repeatPasswordError = "";
      }
    } else if (name === "role") {
      if (!value) {
        validationErrors.roleError = "Please select a Role";
      } else {
        validationErrors.roleError = "";
      }
    } else if (name === "department") {
      if (value.length <= 0) {
        validationErrors.departmentError =
          "Please select at least one Department";
      } else {
        validationErrors.departmentError = "";
      }
    } else if (name === "infoId") {
      if (validation.isNullUndefinedEmpty(value)) {
        validationErrors.infoIdError = "Please enter Infor System Id";
      } else {
        validationErrors.infoIdError = "";
      }
    }

    this.setState({
      user: {
        ...this.state.user,
        [name]: value,
      },
      validationErrors: validationErrors,
    });
  }

  onKeyPress(e) {
    if (
      e.which === 32 ||
      (e.which !== 8 && isNaN(String.fromCharCode(e.which)))
    ) {
      e.preventDefault();
    }
  }

  onClear() {
    let user;
    if (!this.state.edit) {
      user = {
        name: "",
        email: "",
        mobile: "",
        role: "",
        userActivate: true,
        password: "",
        repeatPassword: "",
        department: [],
        infoId: "",
      };
    } else {
      user = {
        name: "",
        email: this.state.user.email,
        mobile: "",
        role: "",
        userActivate: true,
        department: [],
        infoId: "",
      };
    }
    this.setState({
      user: user,
      validationErrors: {},
      msg: "",
      error: "",
    });
  }

  async onSubmit() {
    Loader.showLoader();
    let {
      name,
      infoId,
      email,
      mobile,
      role,
      userActivate,
      password,
      repeatPassword,
      department,
    } = this.state.user;
    let validationErrors = Object.assign({}, this.state.validationErrors);

    let validationFlag = false;

    if (!this.state.edit) {
      if (validation.isNullUndefinedEmpty(email)) {
        validationErrors.emailError = "Please enter Email Address";
        validationFlag = true;
      } else if (!validation.isValidEmail(email)) {
        validationErrors.emailError = "Please provide a valid Email Address";
        validationFlag = true;
      } else {
        validationErrors.emailError = "";
      }
      if (validation.isNullUndefinedEmpty(password)) {
        validationErrors.passwordError = "Please enter Password";
        validationFlag = true;
      } else if (!validation.isValidPasswordFormat(password)) {
        validationErrors.passwordError =
          "Password should be minimum 8 characters long containing atleast 1 Uppercase, 1 Lowercase, 1 Digit and 1 Special Character";
        validationFlag = true;
      } else if (repeatPassword && password !== repeatPassword) {
        validationErrors.repeatPasswordError =
          "Password and Confirm Password must be same";
        validationFlag = true;
      } else {
        validationErrors.passwordError = "";
      }
      if (validation.isNullUndefinedEmpty(repeatPassword)) {
        validationErrors.repeatPasswordError = "Please enter Confirm Password";
        validationFlag = true;
      } else if (password && repeatPassword !== password) {
        validationErrors.repeatPasswordError =
          "Password and Confirm Password must be same";
        validationFlag = true;
      } else {
        validationErrors.repeatPasswordError = "";
      }
    }

    if (validation.isNullUndefinedEmpty(name)) {
      validationErrors.nameError = "Please enter Name";
      validationFlag = true;
    } else if (!validation.isValidName(name)) {
      validationErrors.nameError = "Name can only contain alphabets and space";
      validationFlag = true;
    } else {
      validationErrors.nameError = "";
    }

    if (validation.isNullUndefinedEmpty(mobile)) {
      validationErrors.mobileError = "Please enter Mobile No.";
      validationFlag = true;
    } else if (!validation.isValidMobileNo(mobile)) {
      validationErrors.mobileError = "Please provide Mobile No. of 10 digits";
      validationFlag = true;
    } else {
      validationErrors.mobileError = "";
    }

    if (!role) {
      validationErrors.roleError = "Please select a Role";
      validationFlag = true;
    } else {
      validationErrors.roleError = "";
    }

    if (department.length <= 0) {
      validationErrors.departmentError =
        "Please select at least one Department";
      validationFlag = true;
    } else {
      validationErrors.departmentError = "";
    }
    if (!infoId || infoId.length !== 3) {
      validationErrors.infoIdError = "Please enter three digit Info System Id";
      validationFlag = true;
    } else {
      validationErrors.infoIdError = "";
    }

    this.setState({
      validationErrors: validationErrors,
    });

    if (validationFlag === false) {
      let userData;
      if (!this.state.edit) {
        userData = {
          name: name,
          email: email,
          mobile: mobile,
          password: password,
          role: role,
          infoId: infoId,
          department: department,
          userActivate: userActivate,
        };
      } else {
        userData = {
          userId: this.state.userId,
          name: name,
          mobile: mobile,
          role: role,
          infoId: infoId,
          department: department,
          userActivate: userActivate,
        };
      }
      let { response, err } = !this.state.edit
        ? await userservice.createInternalUser(userData)
        : await userservice.updateInternalUser(userData);
      Loader.hideLoader();
      if (err) {
        this.setState({
          error: err,
          msg: "",
        });
      } else if (response.data && response.data.err) {
        this.setState({
          error: response.data.err,
          msg: "",
        });
      } else {
        this.setState({
          user: {
            name: "",
            email: "",
            mobile: "",
            role: "",
            userActivate: true,
            password: "",
            repeatPassword: "",
            department: [],
            infoId: "",
          },
          validationErrors: {},
          error: "",
          msg: response.data.msg,
          showModel: !this.state.showModel,
        });
        this.getAllInternalUsers();
      }
    } else {
      Loader.hideLoader();
    }
  }

  async getAllInternalUsers() {
    Loader.showLoader();
    let { response, err } = await userservice.getAllInternalUsers();
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState({
        data: response.data,
      });
    }
  }

  componentDidMount() {
    this.props.context.actions.setAccessRights();
    this.props.context.actions.setDepartments();
    this.props.context.actions.setMasters();
    this.getAllInternalUsers();
    let selectRoles = this.props.context.state.masters["Role"];
    this.setState({
      selectDepartments: this.props.context.state.departments,
      selectRoles: selectRoles,
    });
  }

  userMenus(nextProps, action) {
    let menu = nextProps.context.state.accessRights.filter((ele, indx) => {
      return ele.functionality === "User" && ele.entitlement === action;
    });
    if (menu.length > 0) return true;
    else return false;
  }
  // componentWillReceiveProps(nextProps) {
  //   // This lifecycle method is deprecated. Use componentDidUpdate instead.
  // }

  componentDidUpdate(prevProps) {
    if (this.props.context !== prevProps.context) {
      const selectRoles = this.props.context.state.masters["Role"];
      this.setState({
        selectDepartments: this.props.context.state.departments,
        accessRights: this.props.context.state.accessRights,
        selectRoles: selectRoles,
        isAllowCreate: this.userMenus(this.props, "Create"),
        isAllowEdit: this.userMenus(this.props, "Edit"),
        isAllowDelete: this.userMenus(this.props, "Delete"),
      });
    }
  }
  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }
    
    let {
      name,
      infoId,
      email,
      mobile,
      role,
      userActivate,
      password,
      repeatPassword,
      department,
    } = this.state.user;
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-right ">
            {this.state.error ? (
              <span className="msg-style-error">{this.state.error}</span>
            ) : null}
            {this.state.msg ? (
              <span className="msg-style-success">{this.state.msg}</span>
            ) : null}
            {this.state.deleteMsg ? (
              <span className="msg-style-success">{this.state.deleteMsg}</span>
            ) : null}
            {this.state.isAllowCreate ? (
              <button
                className={
                  this.state.showModel
                    ? "btn btn-warning rounded-0 mt-2 mb-2"
                    : "btn btn-success rounded-0 mt-2 mb-2"
                }
                onClick={this.buttonClick}
              >
                {this.state.showModel ? "Close" : "Create"}
              </button>
            ) : null}
          </div>
          <div
            style={
              this.state.showModel ? { display: "none" } : { display: "block" }
            }
            className="col-sm-12"
          >
            <DataTable
              className="data-table"
              keyField="id"
              pagination={{
                enabled: true,
                pageLength: 20,
                type: "long",
              }}
              width="100%"
              headers={this.state.headers}
              data={this.state.data}
              noData="No records!"
            />
          </div>
          {this.state.showModel ? (
            <div className="col-sm-12 admin-create-user">
              <div className="card p-4">
                <form className="">
                  <h3 className="card-title text-center">
                    {this.state.edit ? "Edit User" : "CREATE USER"}
                  </h3>{" "}
                  <hr className="mb-4 mt-2" />
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <label>
                          Name<span className="mandatory">*</span>
                        </label>
                        <input
                          required
                          type="text"
                          value={name || ""}
                          name="name"
                          className={
                            this.state.validationErrors.nameError
                              ? "is-invalid form-control "
                              : "form-control"
                          }
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <span className="error-msg">
                          {this.state.validationErrors.nameError}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group fg-animate ">
                        <label>
                          Email<span className="mandatory">*</span>
                        </label>
                        <input
                          required
                          type="text"
                          value={email || ""}
                          name="email"
                          className={
                            this.state.validationErrors.emailError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          onChange={this.onChange}
                          autoComplete="off"
                          readOnly={this.state.edit ? true : false}
                        />
                        <span className="error-msg">
                          {this.state.validationErrors.emailError}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <label>
                          Mobile<span className="mandatory">*</span>
                        </label>
                        <input
                          required
                          type="text"
                          className={
                            this.state.validationErrors.mobileError
                              ? "is-invalid form-control"
                              : "form-control"
                          }
                          name="mobile"
                          maxLength="10"
                          value={mobile || ""}
                          onChange={this.onChange}
                          onKeyPress={this.onKeyPress}
                          autoComplete="off"
                        />
                        <span className="error-msg">
                          {this.state.validationErrors.mobileError}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mt-3">
                    <label>
                      <strong> Departments : </strong>{" "}
                      <span className="mandatory">*</span> &nbsp;{" "}
                      <span className="error-msg">
                        {this.state.validationErrors.departmentError}
                      </span>
                    </label>
                    <ul className="user-dept">
                      {this.state.selectDepartments &&
                        this.state.selectDepartments.length > 0 &&
                        this.state.selectDepartments.map((x) => {
                          return (
                            <li key={x.deptId}>
                              <input
                                type="checkbox"
                                name="department"
                                onChange={this.onChange}
                                value={x.deptId}
                                checked={
                                  department.some((s) => x.deptId === s)
                                    ? true
                                    : false
                                }
                              />
                              &nbsp;&nbsp;{x.deptName}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                  <div className="row mt-4">
                    {!this.state.edit ? (
                      <React.Fragment>
                        <div className="col-sm-4">
                          <div className="form-group fg-animate">
                            <label>
                              Password<span className="mandatory">*</span>
                            </label>
                            <input
                              required
                              type="password"
                              className={
                                this.state.validationErrors.passwordError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              name="password"
                              value={password || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                            <span className="error-msg">
                              {this.state.validationErrors.passwordError}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group fg-animate">
                            <label>
                              Confirm Password
                              <span className="mandatory">*</span>
                            </label>
                            <input
                              required
                              type="password"
                              className={
                                this.state.validationErrors.repeatPasswordError
                                  ? "is-invalid form-control"
                                  : "form-control"
                              }
                              name="repeatPassword"
                              value={repeatPassword || ""}
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                            <span className="error-msg">
                              {this.state.validationErrors.repeatPasswordError}
                            </span>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : null}

                    <div className="col-sm-4">
                      <div className="form-group ">
                        <div className="row ">
                          <div className="col-sm-12">
                            <label className="">
                              Role<span className="mandatory">*</span>
                            </label>
                            <select
                              name="role"
                              value={role || ""}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option
                                value=""
                                disabled="disabled"
                              >
                                Select
                              </option>
                              {this.state.selectRoles &&
                                this.state.selectRoles.length > 0 &&
                                this.state.selectRoles.map((x) => {
                                  return (
                                    <option key={x.code} value={x.code}>
                                      {" "}
                                      {x.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <span className="error-msg">
                            {this.state.validationErrors.roleError}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <label>
                          Infor System Id<span className="mandatory">*</span>
                        </label>
                        <input
                          required
                          type="text"
                          value={infoId || ""}
                          name="infoId"
                          className={
                            this.state.validationErrors.infoIdError
                              ? "is-invalid form-control "
                              : "form-control"
                          }
                          maxLength="3"
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <span className="error-msg">
                          {this.state.validationErrors.infoIdError}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>Activate </label>
                        <input
                          type="checkbox"
                          className="ml-2"
                          name="userActivate"
                          value={userActivate || true}
                          checked={userActivate ? true : false}
                          onChange={this.onChange}
                        />{" "}
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <button
                        className="btn btn-success rounded-0 ml-2"
                        type="button"
                        onClick={this.onSubmit}
                      >
                        {!this.state.edit ? "Save" : "Update"}
                      </button>
                      <button
                        className="btn btn-default rounded-0 "
                        type="button"
                        onClick={this.onClear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
